// Servicio de notificaciones
export const sendTicketNotification = async (raffleId, ticketNumber, buyerName) => {
  try {
    // Por ahora solo loguear, en el futuro se puede integrar con un servicio de notificaciones push
    console.log(`Notificación: ${buyerName} ha reservado el boleto ${ticketNumber} en la rifa ${raffleId}`);
    
    // Si se implementa un servicio de notificaciones, aquí iría la lógica
    // Por ejemplo: Firebase Cloud Messaging, OneSignal, etc.
    
    return true;
  } catch (error) {
    console.error('Error sending notification:', error);
    return false;
  }
};

// Función para solicitar permisos de notificación en el navegador
export const requestNotificationPermission = async () => {
  try {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    }
    return false;
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
};

// Función para mostrar notificación en el navegador
export const showBrowserNotification = (title, options = {}) => {
  try {
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification(title, {
        icon: '/icon-192x192.png',
        badge: '/icon-192x192.png',
        ...options
      });
    }
  } catch (error) {
    console.error('Error showing notification:', error);
  }
};